import React from 'react'
import { DialogContent, FormDialog } from '@front/squirtle'

import MultipleDispatch from './MultipleDispatch'

const Popup = ({ submitMultipleDispatch }) => (
  <FormDialog
    name={'multi_dispatch'}
    maxWidth='xl'
    formProps={{
      onSubmit: submitMultipleDispatch,
    }}
  >
    <DialogContent>
      <MultipleDispatch />
    </DialogContent>
  </FormDialog>
)

export default React.memo(Popup)
